//@ts-check
import { Controller } from "@hotwired/stimulus";
import { mustBeHtmlElement } from "common/dom-utils";
import { getCsrfToken } from "common/utils/rails";
import { PurchasingSectionComponent } from "../components/purchasing-section/PurchasingSectionComponent";

function extendUrl(url, query) {
  if (!url) return null;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${query}`;
}

/**
 * Controller to handle the buttons for adding/removing items from the shopping cart.
 * Calls backend (Store::ShoppingCartItemsController) to save data and updates the DOM based on the response JSON.
 * Buttons defined in app/helpers/store/application_helper.rb
 */
export default class extends Controller {
  static targets = ["total"];

  connect() {
    this.purchasingSection = PurchasingSectionComponent.getInstance();
  }

  async add(event) {
    console.log("Add to cart clicked");
    event.preventDefault();
    event.stopPropagation();
    const link = event.currentTarget;
    if (link.classList.contains("disabled")) return;
    const url = extendUrl(
      link.getAttribute("href"),
      `font_family_id=${this.purchasingSection.fontFamilyId}`
    );

    await this.request(url, { method: "POST" });
  }

  async remove(event) {
    console.log("Remove from cart clicked");
    event.preventDefault();
    event.stopPropagation();
    const link = event.currentTarget;
    const url = extendUrl(
      link.getAttribute("href"),
      `font_family_id=${this.purchasingSection.fontFamilyId}`
    );
    await this.request(url, { method: "DELETE" });
  }

  noop(event) {
    console.log("Included button clicked - no action");
    event.preventDefault();
    event.stopPropagation();
  }

  // ---- private

  async request(url, options) {
    try {
      const res = await fetch(url, {
        ...options,
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": getCsrfToken(),
        },
        credentials: "same-origin",
      });

      const data = await res.json();

      if (!res.ok) {
        this.handleError(data);
        return;
      }

      this.updateDom(data);
    } catch (e) {
      console.error("Error while updating cart:", e);
      alert("Something went wrong while updating your cart.");
    }
  }

  handleError(data) {
    const message = data?.error || "There was a problem with your request.";
    alert(message);
  }

  updateDom(payload) {
    // Payload generated in shopping_cart_items#cart_payload
    console.log("Processing response:", payload);

    this.purchasingSection.updateFromPayload(payload);
  }
}
